import { FC } from 'react'

import { NumberCellTypes } from './number-cell.types'

export const NumberCell: FC<NumberCellTypes> = ({
  upperText,
  bottomText,
  color = 'var(--green-50)',
  showSign = true,
}) => {
  return (
    <div
      className="max-w-32 flex w-fit flex-col items-center justify-center"
      /*
         style tag is used temporarily here. will remove when global color styles implemented  
      */
      style={{ color: color }}
    >
      <div className="flex items-center">
        <p
          className={`m-0 font-montserrat text-sm font-semibold text-[${color}]`}
        >
          {upperText}
        </p>
        {showSign && (
          <p
            className={`m-0 font-montserrat text-sm font-semibold md:text-xs md:font-normal lg:text-xs lg:font-normal text-[${color}]`}
          >
            %
          </p>
        )}
      </div>
      <div>
        <p className="m-0 mt-0.5 font-montserrat text-xs font-light text-grey-50">
          {bottomText}
        </p>
      </div>
    </div>
  )
}
